(function () {
  // Auf Klicks im mobilen Menü hören – Text soll wie der Pfeil aufklappen
  document.addEventListener('click', function (e) {
    // Nur Hauptlinks innerhalb von li.sub im nav#nav
    const mainLink = e.target.closest('#nav li.sub > a:not(.toggle):not(.toggle-back)');
    if (!mainLink) return;

    const item = mainLink.closest('li.sub');
    if (!item) return;

    // Wenn es einen offiziellen Toggle-Link gibt, nutze ihn
    const toggleLink = item.querySelector(':scope > a.toggle');

    // Navigation verhindern – wir wollen zuerst auf-/zuklappen
    e.preventDefault();
    e.stopImmediatePropagation();

    if (toggleLink) {
      // Theme-Logik auslösen (bubbles/cancelable, damit es wie ein echter Klick ist)
      const evt = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
      toggleLink.dispatchEvent(evt);
      return;
    }

    // Fallback: selbst toggeln (falls kein .toggle vorhanden)
    const isOpen = item.classList.contains('hover') || item.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      item.classList.remove('hover');
      item.setAttribute('aria-expanded', 'false');
    } else {
      item.classList.add('hover');
      item.setAttribute('aria-expanded', 'true');
    }
  }, true); // capture: true -> kommt vor Theme-Handlern dran
})();
